import React from 'react';
import SentimentScore from '../components/SentimentScore';

export default function SentimentSection({ score, breakdown }) {
  return <SentimentScore score={score} breakdown={breakdown} />;
}
